import React from 'react'

import Box from 'components_new/atoms/Box'

import { BOARD } from './accents'

/**
 * Small dark square badge marking which input a field row belongs to
 * (L/R on left join and unite, A/B on concatenate).
 */
const SideBadge = (props: { label: string }) => (
  <Box
    component="span"
    sx={{
      alignItems: 'center',
      backgroundColor: BOARD.textPrimary,
      borderRadius: '5px',
      color: 'common.white',
      display: 'inline-flex',
      flex: 'none',
      fontFamily: BOARD.fontBody,
      fontSize: '9.5px',
      fontWeight: 700,
      height: '16px',
      justifyContent: 'center',
      width: '16px'
    }}
  >
    {props.label}
  </Box>
)

export default SideBadge
